import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

type GetAdministratedPortfolio = {
  userId: string;
  societyId?: string;
  signal?: AbortSignal;
};

export const getAdministratedPortfolio =
  ({ userId, societyId, signal }: GetAdministratedPortfolio) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/societies/administrated-portfolio`, {
        params: {
          userId,
          societyId,
        },
        // signal,
      });

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
